var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{staticClass:"py-1",attrs:{"no-body":""}},[_c('FeedHeader',{attrs:{"business":_vm.business}}),_c('FeedContent',{attrs:{"type":_vm.type}}),_c('FeedSocialButtons')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }